import {ChangeEvent, FC} from 'react'
import {SelectInterface} from './types'

const Select: FC<SelectInterface> = ({formik, name, options, onChange}) => {

  const fieldProps = formik.getFieldProps(name)

  // Handle the change event
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    fieldProps.onChange(e);
    if (onChange) {
      onChange(e);
    }
  };


  return (
    <div className="form-group">
      {/*<label htmlFor={name}>{label}</label>*/}
      <select className="form-select form-select-solid form-select-sm"
              id={name}
              {...fieldProps}
              onChange={handleChange}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export {Select}